import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../../../@prep/shared/material-components.module';

import { LanguageSelectorModule } from 'src/@prep/shared/language-selector/language-selector.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';


@NgModule({
  imports: [
    CommonModule,
    LoginRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    LanguageSelectorModule
  ],
  declarations: [LoginComponent],
})
export class LoginModule { }
